import React from 'react';

export default function CashAdvanceReport() {
  return <div>CashAdvanceReport</div>;
}
